import classNames from 'classnames';
import css from './CustomBanner.module.css';

const CustomBanner = props => {
  const { rootClassName, className, intl } = props;
  const classes = classNames(rootClassName || css.root, className);

  const internalLink = (
    <span
      onClick={() =>
        handleLinkClick('internal', `${intl.formatMessage({ id: 'CustomBanner.internalLink' })}`)
      }
      className={css.link}
    >
      {intl.formatMessage({ id: 'CustomBanner.messageWithInternalLinkText' })}
    </span>
  );
  const messageWithInternalLinkString = intl.formatMessage(
    {
      id: 'CustomBanner.messageWithInternalLink',
    },
    { messageWithInternalLink: internalLink }
  );

  const externalLink = (
    <span
      onClick={() =>
        handleLinkClick('external', `${intl.formatMessage({ id: 'CustomBanner.externalLink' })}`)
      }
      className={css.link}
    >
      {intl.formatMessage({ id: 'CustomBanner.messageWithExternalLinkText' })}
    </span>
  );
  const messageWithExternalLinkString = intl.formatMessage(
    {
      id: 'CustomBanner.messageWithExternalLink',
    },
    { messageWithExternalLink: externalLink }
  );

  const messageString = intl.formatMessage({ id: 'CustomBanner.message' });
  const containsMessage = messageString !== 'CustomBanner.message';
  const containsMessageWithInternalLink =
    messageWithInternalLinkString !== 'CustomBanner.messageWithInternalLink';
  const containsMessageWithExternalLink =
    messageWithExternalLinkString !== 'CustomBanner.messageWithExternalLink';

  const showBanner =
    containsMessage || containsMessageWithInternalLink || containsMessageWithExternalLink;

  const handleLinkClick = (type, url) => {
    if (type === 'internal') {
      window.location.href = url;
    } else {
      window.open(url, '_blank');
    }
  };

  return showBanner ? (
    <div className={classes}>
      <p className={css.text}>
        {containsMessage
          ? messageString
          : containsMessageWithInternalLink
          ? messageWithInternalLinkString
          : containsMessageWithExternalLink
          ? messageWithExternalLinkString
          : null}
      </p>
    </div>
  ) : null;
};

export default CustomBanner;
